import { render, staticRenderFns } from "./StanleyMessageFeedback.vue?vue&type=template&id=59ddfda9&scoped=true"
import script from "./StanleyMessageFeedback.vue?vue&type=script&lang=js"
export * from "./StanleyMessageFeedback.vue?vue&type=script&lang=js"
import style0 from "./StanleyMessageFeedback.vue?vue&type=style&index=0&id=59ddfda9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ddfda9",
  null
  
)

export default component.exports